import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-news-category' })
export class NewsCategoryComponent {
	constructor(private element: HTMLElement) {
		this.addClickListener();
	}

	addClickListener() {
		this.element.addEventListener('click', function () {
			const redirectUrl = this.getAttribute('data-category');
			var isEnglish = window.location.href.indexOf('/en') > -1;
			if (isEnglish) {
				location.href = '/en/news/#' + redirectUrl;
			} else {
				location.href = '/news/#' + redirectUrl;
			}
		});
	}
}
